<template>
  <div>
    <form @submit.prevent="createSavingReason">
      <modal
        v-show="isSavingReasonModal"
        @close="closeSavingReasonModal"
        footer
      >
        <template v-slot:title>
          <h5>Update Collateral</h5>
        </template>
        <template v-slot:body>
          <div class="form-group">
            <label for="title">Title</label>
            <input
              type="text"
              class="form-control"
              name="title"
              v-model="savingReason.name"
            />
          </div>
          <div class="form-group">
            <label for="status">Status</label> <br />
            <select
              id="select"
              class="form-select fw-two form-control"
              v-model="savingReason.status"
            >
              <option value="active" class="mb-2">Active</option>
              <option value="in-active" class="mb-2">
                Inactive
              </option>
            </select>
          </div>
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
            :disabled="creatingSavingReasonLoading || !formIsValid"
          >
            <span class="custom-loader" v-if="creatingSavingReasonLoading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;"
                >Updating Saving Reason...</span
              >
            </span>
            <span v-else>
              Update Saving Reason
            </span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeSavingReasonModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>
    <loader-ring
      v-if="getSavingReasonLoading"
      class="loader-center"
    ></loader-ring>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Collaterals</h1>
        </div>
        <div class="col-auto">
          <button
            class="button button--outline text-uppercase"
            @click="showSavingReasonModal"
          >
            Add Collateral
          </button>
        </div>
      </div>

      <div class="card card--no-shadow">
        <div class="card-header">
          <slot name="header">
            <h4 class="card-title">Collateral</h4>
          </slot>
        </div>
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="savingReasons"
              :fields="fields"
              :items-per-page="small ? 10 : 5"
              pagination
              sorter
              tableFilter
            >
              <template #updated_at="{item}">
                <td class="table--action-mobile">
                  {{ item.updated_at | date }}
                </td>
              </template>
              <template #action="{item}">
                <td class="table--action-mobile">
                  <!-- <router-link class="button" :to="{name: 'Remittance Plan', params: {slug: item.id}}">
                                        View
                                    </router-link> -->
                  <button
                    class="button btn-sucess"
                    @click="showUpdateModal(item)"
                    style="background-color: #0bc681;"
                  >
                    Update
                  </button>
                </td>
              </template>
            </CDataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "@/components/CDataTable.vue";
import ApiService from "@/services/api.service";
import ErrorService from "@/services/error.service";
import Swal from "sweetalert2";

const fields = ["name", "status", "action"];
export default {
  name: "SavingReasons",
  components: {
    CDataTable
  },
  data() {
    return {
      currentDate: Date.now(),
      fields,
      small: true,

      getSavingReasonLoading: false,
      isSavingReasonModal: false,
      creatingSavingReasonLoading: false,
      savingReasons: [
        {
          name: "Vehicle",
          status: "active"
        },
        {
          name: "Machinery/Equipment",
          status: "active"
        },
        {
          name: "Property",
          status: "active"
        },
        {
          name: "Goods/Commodities",
          status: "active"
        },
        {
          name: "Financial Instruments",
          status: "active"
        }
      ],
      savingReason: {
        // group: "",
        // body: "",
        // delivery_time: new Date(),
        // title: ""
      }
    };
  },
  computed: {
    formIsValid() {
      return this.savingReason.status !== "" && this.savingReason.name !== "";
    }
  },
  methods: {
    showUpdateModal(item) {
      this.savingReason = Object.assign({}, item);
      this.showSavingReasonModal();
      console.log(this.savingReason);
    },
    closeSavingReasonModal() {
      this.isSavingReasonModal = false;
      this.savingReason = {};
    },
    showSavingReasonModal() {
      this.isSavingReasonModal = true;
    },
    async getSavingReasons() {
      try {
        this.getSavingReasonLoading = true;
        const response = await ApiService.get(
          "backend/settings/all-saving-reasons"
        );
        this.savingReasons = response.data.data;
        this.getSavingReasonLoading = false;
      } catch (error) {
        this.getSavingReasonLoading = false;
        console.log(error.response);
      }
    },
    async createSavingReason() {
      try {
        this.creatingSavingReasonLoading = true;
        const response = await ApiService.post(
          "backend/settings/create-update-save-reason",
          this.savingReason
        );
        this.creatingSavingReasonLoading = false;
        this.closeSavingReasonModal();
        this.getSavingReasons();

        Swal.fire({
          title: "Success",
          text: response.data.response_message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
      } catch (error) {
        this.creatingSavingReasonLoading = false;
        this.closeSavingReasonModal();
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        console.log(_error);
      }
    }
  },
  mounted() {
    // this.getSavingReasons();
  }
};
</script>

<style scoped></style>
